import React from 'react';

const QuestionMarkIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99989 16.6995C13.1337 16.6995 16.4849 13.3483 16.4849 9.21449C16.4849 5.08064 13.1337 1.72949 8.99989 1.72949C4.86604 1.72949 1.51489 5.08064 1.51489 9.21449C1.51489 13.3483 4.86604 16.6995 8.99989 16.6995ZM7.64455 6.90329C7.64677 6.8914 7.65849 6.84828 7.68276 6.78521C7.72605 6.67274 7.78755 6.55953 7.86892 6.45533C8.10251 6.15619 8.45295 5.97938 8.99751 5.98188C10.0321 5.98665 10.546 7.32636 9.93674 7.9462C9.60971 8.28041 9.30626 8.58162 8.99863 8.88061C8.6524 9.22117 8.45911 9.68362 8.45999 10.166L8.45999 10.8897C8.45999 11.188 8.70175 11.4297 8.99999 11.4297C9.29822 11.4297 9.53999 11.188 9.53999 10.8897V10.165C9.53964 9.97185 9.61665 9.7876 9.75367 9.65281C10.065 9.35021 10.3747 9.04279 10.7078 8.70239C11.9726 7.41555 11.012 4.91117 9.00248 4.90189C8.11718 4.89783 7.45332 5.23278 7.01771 5.79062C6.86638 5.98441 6.75443 6.19048 6.67483 6.39729C6.62538 6.52578 6.59661 6.63165 6.58292 6.70491C6.52814 6.99807 6.72139 7.28013 7.01455 7.33491C7.30771 7.38969 7.58977 7.19644 7.64455 6.90329ZM9.63365 12.9646C9.63365 13.3146 9.34991 13.5983 8.99989 13.5983C8.64988 13.5983 8.36614 13.3146 8.36614 12.9646C8.36614 12.6145 8.64988 12.3308 8.99989 12.3308C9.34991 12.3308 9.63365 12.6145 9.63365 12.9646Z"
        fill="#333333"
      />
      <mask
        id="mask0_606_69727"
        style={{maskType: "luminance"}}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="16"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.99989 16.6995C13.1337 16.6995 16.4849 13.3483 16.4849 9.21449C16.4849 5.08064 13.1337 1.72949 8.99989 1.72949C4.86604 1.72949 1.51489 5.08064 1.51489 9.21449C1.51489 13.3483 4.86604 16.6995 8.99989 16.6995ZM7.64455 6.90329C7.64677 6.8914 7.65849 6.84828 7.68276 6.78521C7.72605 6.67274 7.78755 6.55953 7.86892 6.45533C8.10251 6.15619 8.45295 5.97938 8.99751 5.98188C10.0321 5.98665 10.546 7.32636 9.93674 7.9462C9.60971 8.28041 9.30626 8.58162 8.99863 8.88061C8.6524 9.22117 8.45911 9.68362 8.45999 10.166L8.45999 10.8897C8.45999 11.188 8.70175 11.4297 8.99999 11.4297C9.29822 11.4297 9.53999 11.188 9.53999 10.8897V10.165C9.53964 9.97185 9.61665 9.7876 9.75367 9.65281C10.065 9.35021 10.3747 9.04279 10.7078 8.70239C11.9726 7.41555 11.012 4.91117 9.00248 4.90189C8.11718 4.89783 7.45332 5.23278 7.01771 5.79062C6.86638 5.98441 6.75443 6.19048 6.67483 6.39729C6.62538 6.52578 6.59661 6.63165 6.58292 6.70491C6.52814 6.99807 6.72139 7.28013 7.01455 7.33491C7.30771 7.38969 7.58977 7.19644 7.64455 6.90329ZM9.63365 12.9646C9.63365 13.3146 9.34991 13.5983 8.99989 13.5983C8.64988 13.5983 8.36614 13.3146 8.36614 12.9646C8.36614 12.6145 8.64988 12.3308 8.99989 12.3308C9.34991 12.3308 9.63365 12.6145 9.63365 12.9646Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_606_69727)">
        <rect y="0.214355" width="18" height="18" fill="#282828" />
      </g>
    </svg>
  );
};

export default QuestionMarkIcon;
